import React from 'react';

import styles from './DestinationOption.module.scss';
import { REINVEST_STEP } from '../../settings/settings';
import checkMark from '../../assets/images/checkmark.svg';
import lock from '../../assets/images/lock.svg';
import cancel from '../../assets/images/cancel.svg';

const DestinationOption = ({
  optionText,
  selectOption,
  disabled,
  isSelected,
  selectable,
  rollLastFund,
  destinationStep,
  reinvest,
  customFunds,
  isLockedFund,
  tradLastFund,
  proportionateFunds,
  addressLock,
  blockContainer,
  withHolding,
  withHoldingError,
  value,
  nonRetirementFunds,
}) => {
  return (
    <div
      className={`${isSelected ? styles.selected : ''}
      ${
        !disabled
          ? styles['destination-option-container']
          : styles['disabled-option-container']
      }
      ${selectable && !disabled ? styles.selectable : ''}
      ${!reinvest && styles['option-container-flexbox']}
      ${!reinvest && blockContainer && styles['block-container-flexbox']} 
      ${reinvest && styles['reinvest-container']} 
      ${withHoldingError && styles['tax-error-container']} 
      ${(tradLastFund || rollLastFund) && styles['reinvest-lastfund']}`}
      onClick={!disabled ? selectOption : () => {}}
    >
      {!withHoldingError && (
        <img
          src={checkMark}
          alt=""
          className={`${isSelected ? '' : styles.hidden} ${
            withHolding && styles['cancel-icon']
          } ${styles['check-img']} ${
            destinationStep && styles['dest-check-img']
          } ${value === REINVEST_STEP && styles['reinvest-check-mark']}`}
        />
      )}
      {disabled && addressLock && (
        <img className={styles['lock-img']} alt="lock" src={lock} />
      )}
      {withHoldingError && (
        <img
          className={`${styles['check-img']} ${styles['cancel-icon']}`}
          alt=""
          src={cancel}
        />
      )}

      <div
        className={`${!reinvest && styles['option-text']} ${
          isLockedFund && styles['option-text-locked-funds']
        }`}
      >
        {optionText}{' '}
        {value === REINVEST_STEP && !disabled && nonRetirementFunds !== 0 && (
          <span className={styles['reinvest-msg']}>
            If you don't need the money immediately, consider investing it in a
            <span className="orphan-line"> non-retirement account.</span>
          </span>
        )}
        {value === REINVEST_STEP && !disabled && nonRetirementFunds === 0 && (
          <span className={styles['reinvest-msg-nonretirement']}>
            Open a new Individual registration to reinvest your RMD. You will be
            able to select a fund next.
          </span>
        )}
      </div>
      {!proportionateFunds && customFunds && !rollLastFund && (
        <hr className={styles['horizontal-line']} />
      )}
      {proportionateFunds && !rollLastFund && !tradLastFund && (
        <hr className={styles['horizontal-line']} />
      )}
    </div>
  );
};

export default DestinationOption;
